import { normalizeBoolean } from './boolean'

const checkUserAttribute = (trigger, user) => {
  if (!user) return null

  switch (trigger.model_attribute) {
    case 'current_user_id':
      return compareId(trigger, user.id)
    case 'current_user_team_id':
      return compareId(trigger, user.team_id)
    case 'current_user_is_admin':
      return compareBoolean(trigger, user.is_account_admin)
    default:
      return null
  }
}

export default checkUserAttribute

const parseIdOperand = (operand) => {
  if (operand === null || operand === undefined) return []
  const list = Array.isArray(operand) ? operand : String(operand).split(',')
  return list.map(v => parseInt(String(v).trim(), 10)).filter(n => Number.isFinite(n) && n !== 0)
}

const compareId = (trigger, value) => {
  const ids = parseIdOperand(trigger.operand)
  const matched = value !== null && value !== undefined && ids.includes(parseInt(value, 10))

  if (trigger.name === 'Is' && matched) return { message: 'is selected user' }
  if (trigger.name === 'IsNot' && !matched) return { message: 'is not selected user' }
  return null
}

const compareBoolean = (trigger, value) => {
  const operand = normalizeBoolean(trigger.operand)
  const actual = normalizeBoolean(value)

  if (trigger.name === 'Is' && actual === operand) return { message: `is ${operand}` }
  if (trigger.name === 'IsNot' && actual !== operand) return { message: `is not ${operand}` }
  return null
}
